import { ClientSideNavManager } from '../../content/ClientSideNav';

export const toggleSideNavigation = (open: boolean) => {
  ClientSideNavManager.getInstance().setExpanded(open);
};

export const clickOnElement = (elementSelector: string) => {
  const elm = document.querySelector(`[data-user-guide-id="${elementSelector}"]`) as HTMLElement;
  elm.click();
};

export const PlatformInteractions = {
  toggleSideNavigation,
  clickOnElement,
};
